import { Box, Center, Icon, useBreakpointValue } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import SwiperCore, { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import useScreen from "../../hooks/useScreen";
// import { Color } from "../../interfaces/HairTransfer";
import { ColorItem } from "../HairColorItem/HairColorItem";
import { NavigationButton } from "../SwiperNavigationButton/NavigationButton";

import { SwitchIcon } from "../../assets/switch";
import { Channel } from "../../interfaces/tracking";
import { Analytics, EventNames } from "../../utils/tracking";

SwiperCore.use([Navigation]);

interface hairColorCarrouselProps {
  selectedColor: any;
  colorList: any;
  screen: string;
  disable?: boolean;
  isByColor?: boolean;
  setFilter?: (value: boolean) => void;
}

export const HairColorCarousel = (props: hairColorCarrouselProps) => {
  const { selectedColor, colorList, screen, disable, isByColor, setFilter } =
    props;
  const { isMobile } = useScreen();
  const swiperRef = useRef<SwiperCore>();

  const slidesPerViewColor = useBreakpointValue({
    base: 3,
    sm: 5,
    md: 6,
    lg: 6.5,
  });

  const sortedColorList = colorList
    ? isByColor
      ? [...colorList].sort((a, b) => a.position - b.position)
      : [...colorList]
    : [];

  const onClickSwitchButton = () => {
    Analytics.event(Channel.GA, EventNames.SORT_CLICKED, {
      device: isMobile ? "mobile" : "desktop",
      sort: !isByColor ? "color" : "brand",
    });
    setFilter ? setFilter(!isByColor) : undefined;
  };

  useEffect(() => {
    swiperRef.current?.slideTo(0, 300);
  }, [isByColor]);

  return (
    <div style={{ width: "100%", backgroundColor: "#FAFAFA" }}>
      <div
        style={{
          position: "relative",
          width: isMobile ? "100%" : "70%",
          margin: isMobile ? "0" : "0 auto",
          display: "flex",
        }}
      >
        <Box
          alignItems="center"
          cursor="pointer"
          paddingTop="4px"
          paddingBottom="4px"
          width="wrap-content"
          height="wrap-content"
          display={"flex"}
          flexDirection={"column"}
          onClick={
            setFilter && !disable ? () => onClickSwitchButton() : undefined
          }
          _hover={
            !disable
              ? {
                  transform: "scale(1.05)",
                  transition: "transform 0.25s",
                }
              : undefined
          }
        >
          <Center
            border={"1px solid #E6E6E6"}
            borderRadius="full"
            display={"flex"}
            height={isMobile ? "46px" : "58px"}
            width={isMobile ? "46px" : "58px"}
            mt={{ base: "25px" }}
            mr={"35px"}
            ml={"25px"}
          >
            <Icon
              fontSize={"26px"}
              bgSize={{ base: 30, md: "26px" }}
              bgColor={isByColor ? "#fff" : "#E90B5A"}
              color={isByColor ? "#E90B5A" : "#fff"}
              opacity={disable ? 0.5 : undefined}
              bgPosition="center"
              bgRepeat="no-repeat"
              borderRadius="full"
              borderColor={isByColor ? "#E90B5A" : "#fff"}
              border={isByColor ? "1px solid" : "none"}
              height={isMobile ? "46px" : "58px"}
              width={isMobile ? "46px" : "58px"}
            >
              <SwitchIcon />
            </Icon>
          </Center>
          <Box
            textAlign="center"
            justifyContent={"center"}
            fontSize={{ base: "14px", md: "14px" }}
            lineHeight="15px"
            letterSpacing="0.2px"
            fontWeight="normal"
            pr={"30px"}
            pl={"20px"}
            pt={"5px"}
            width="100%"
            display={"flex"}
          >
            {`Sort by ${isByColor ? "Brand" : "Color"}`}
          </Box>
        </Box>
        <Swiper
          onInit={(core: SwiperCore) => (swiperRef.current = core)}
          slidesPerView={slidesPerViewColor}
          spaceBetween={17}
          style={{
            paddingLeft: "0px",
            paddingRight: isMobile ? "16px" : "0",
            paddingBottom: "16px",
            paddingTop: "16px",
          }}
          navigation={
            isMobile
              ? false
              : {
                  nextEl: ".swiper-button-next-styles",
                  prevEl: ".swiper-button-prev-styles",
                }
          }
          observer={true}
          observeParents={true}
          observeSlideChildren={true}
        >
          {sortedColorList.map((item, index) => (
            <SwiperSlide key={index} style={{ display: "flex" }}>
              <ColorItem
                color={item}
                colorList={colorList}
                selected={selectedColor === item}
                screen={screen}
                disable={disable}
                isByColor={isByColor}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        {!isMobile && (
          <>
            <NavigationButton
              direction="right"
              className="swiper-button-next-styles"
            />

            <NavigationButton
              direction="left"
              className="swiper-button-prev-styles"
            />
          </>
        )}
      </div>
    </div>
  );
};
